import { render } from "./talonItems.vue?vue&type=template&id=301f8869&scoped=true"
import script from "./talonItems.vue?vue&type=script&lang=js"
export * from "./talonItems.vue?vue&type=script&lang=js"

import "./talonItems.vue?vue&type=style&index=0&id=301f8869&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-301f8869"]])

export default __exports__